if (!customElements.get('lookbook-icon')) {
  customElements.define(
    'lookbook-icon',
    class LookbookIcon extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          cardContainer: '.lookbook-card',
          cardProduct: '.lookbook-icon__card',
        };

        this.cardContainer = this.closest(this.selectors.cardContainer);
        this.cardProduct = this.querySelector(this.selectors.cardProduct);

        this.init();
        document.addEventListener('matchMobile', () => {
          this.init();
        });
        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
        this.addEventListener('mouseover', this.init.bind(this));

        this.trackOpen = this.trackOpen.bind(this);
        // The card is revealed by :hover / :focus in CSS, so "opened" has to be
        // observed from the same interactions. pointerup covers touch, where
        // there is no hover at all.
        this.addEventListener('mouseenter', this.trackOpen);
        this.addEventListener('focusin', this.trackOpen);
        this.addEventListener('pointerup', this.trackOpen);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseover', this.init.bind(this));
        this.removeEventListener('mouseenter', this.trackOpen);
        this.removeEventListener('focusin', this.trackOpen);
        this.removeEventListener('pointerup', this.trackOpen);
      }

      /**
       * GA4 select_content when the hotspot opens. Once per hotspot per page:
       * hover, focus and tap can all fire for a single opening, and brushing
       * past the same hotspot repeatedly is not new engagement.
       */
      trackOpen() {
        if (this.gxTracked || !window.BritaGx) return;
        const event = this.getAttribute('data-gx-open-event');
        if (!event) return;
        this.gxTracked = true;
        window.BritaGx.track(event, {
          content_type: this.getAttribute('data-gx-open-content-type') || '',
          content_id: this.getAttribute('data-gx-open-content-id') || '',
        });
      }

      init() {
        this.classes = '';
        if (this.cardProduct) {
          this.cardContainerOffsetX = this.cardContainer.getBoundingClientRect().left;
          this.cardContainerOffsetY = this.cardContainer.getBoundingClientRect().top;

          this.offsetX = this.getBoundingClientRect().left - this.cardContainerOffsetX;
          this.offsetY = this.getBoundingClientRect().top - this.cardContainerOffsetY;

          this.width = this.clientWidth
          this.cardWidth = this.cardProduct.clientWidth;
          this.cardHeight = this.cardProduct.clientHeight;
          this.wrapperWidth = this.cardContainer.clientWidth
          this.wrapperHeight = this.cardContainer.clientHeight

          this.cardPosition = this.offsetY > this.cardHeight ? 'top' : 'bottom'

          if ((this.offsetX + this.width) > this.cardWidth) {
            this.cardPosition += '-left'
          } else if ((this.wrapperWidth - this.offsetX) > this.cardWidth) {
            this.cardPosition += '-right'
          }

          this.dataset.position = this.cardPosition;
        }

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', () => {
            this.cardProduct.style.transition = 'none';
            this.classList.add('is-active');
          });

          this.addEventListener('shopify:block:deselect', () => {
            this.classList.remove('is-active');
          });
        }
      }
    }
  );
}
